import { ITableRow } from '../Table.types';
import classes from './TableRow.module.css';

export const TableRow = (props: ITableRow) => {
    const { children, onClick, className, isHeader } = props;

    const rowClass = `${isHeader ? classes.headerRow : classes.tableRow} ${className || ''} ${onClick ? classes.clickable : ''}`;

    return (
        <tr className={rowClass} onClick={onClick}>
            {children}
        </tr>
    );
};
